// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ────────────────────────────────────────────────────────────────────────────
   SwitchWiringCanvas — diseñador visual de interconexión de switches (Visio)
   ──────────────────────────────────────────────────────────────────────────── */

.swd-page {
  --swd-accent: #3b82f6;
  --swd-grid-dot: rgba(148, 163, 184, 0.35);
  display: flex;
  flex-direction: column;
  height: calc(100vh - 196px);
  min-height: 420px;
  background: var(--bg-card);
  color: var(--text-primary);
  -webkit-user-select: none;
          user-select: none;
}
/* Dentro de la pestaña Cableado hay además la barra de pestañas. */
.swd-page.is-tabbed { height: calc(100vh - 250px); }

/* Portátil bajo (14"): el relleno de página se recorta (MainLayout.css), así
   que al lienzo le toca más alto. Mismo cálculo: viewport − barra superior −
   migas − relleno del contenido. */
@media (max-height: 820px) {
  .swd-page,
  .swd-page.is-tabbed { height: calc(100dvh - 150px); }
}

/* Pantalla completa: el lienzo ocupa todo el viewport. */
.swd-page:fullscreen,
.swd-page.is-fullscreen {
  width: 100vw;
  height: 100vh;
  border-radius: 0;
}
.swd-page:fullscreen.is-tabbed,
.swd-page.is-fullscreen.is-tabbed { height: 100vh; }

/* ── Barra de herramientas ───────────────────────────────────────────────── */
.swd-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0.6rem 1rem;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
  flex-wrap: wrap;
  flex-shrink: 0;
}
.swd-title {
  font-weight: 700;
  font-size: 0.9rem;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
/* Icono del título (heroicons), compartido por los dos diseñadores. */
.swd-title .cbd-ico {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  stroke-width: 1.8;
  color: var(--swd-accent);
}
.swd-stats {
  font-size: 0.74rem;
  color: var(--text-muted);
  white-space: nowrap;
}
.swd-spacer { flex: 1 1; }
.swd-sel-hint {
  font-size: 0.73rem;
  font-weight: 700;
  color: #b45309;
  background: var(--amber-50, #fef3c7);
  border: 1px solid rgba(245, 158, 11, 0.45);
  border-radius: 6px;
  padding: 3px 9px;
  white-space: nowrap;
}

/* Selector de escenario (producción / diseño / sede) */
.swd-scenario {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--text-muted);
  white-space: nowrap;
}
.swd-scenario select {
  padding: 4px 8px;
  border-radius: 7px;
  border: 1px solid var(--slate-300, #cbd5e1);
  background: var(--bg-input, var(--bg-toolbar));
  color: var(--text-primary);
  font-size: 0.78rem;
  font-weight: 600;
}

.swd-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 11px;
  border-radius: 7px;
  border: 1px solid var(--slate-300, #cbd5e1);
  background: var(--bg-input, var(--bg-toolbar));
  color: var(--text-primary);
  font-size: 0.79rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.12s, border-color 0.12s;
}
.swd-btn:hover { border-color: var(--swd-accent); }
.swd-btn:disabled { opacity: 0.55; cursor: default; }
.swd-btn.is-primary {
  background: var(--swd-accent);
  border-color: var(--swd-accent);
  color: #fff;
}
.swd-btn.is-danger {
  background: #dc2626;
  border-color: #dc2626;
  color: #fff;
}
.swd-btn.is-ghost { background: transparent; }
.swd-btn.is-on {
  border-color: var(--swd-accent);
  color: var(--swd-accent);
  background: rgba(var(--accent-rgb), 0.1);
}

.swd-link {
  border: none;
  background: none;
  color: var(--swd-accent);
  font-size: 0.72rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}
.swd-link:hover { text-decoration: underline; }

/* ── Avisos ──────────────────────────────────────────────────────────────── */
.swd-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0.4rem 1rem;
  font-size: 0.79rem;
  border-bottom: 1px solid var(--border);
}
.swd-banner.is-error {
  background: var(--error-bg, #fef2f2);
  color: var(--error-text, #b91c1c);
}
.swd-banner.is-notice {
  background: rgba(59, 130, 246, 0.1);
  color: var(--text-primary);
}
.swd-banner button {
  margin-left: auto;
  border: none;
  background: none;
  color: inherit;
  font-size: 1rem;
  cursor: pointer;
  line-height: 1;
}

/* ── Cuerpo: lateral + lienzo ────────────────────────────────────────────── */
.swd-body {
  display: flex;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.swd-side {
  width: 268px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--border);
  background: var(--bg-card);
  min-height: 0;
}
.swd-search {
  margin: 0.6rem 0.7rem 0.35rem;
  padding: 0.38rem 0.55rem;
  border-radius: 7px;
  border: 1px solid var(--slate-300, #cbd5e1);
  background: var(--bg-input, var(--bg-toolbar));
  color: var(--text-primary);
  font-size: 0.78rem;
}
.swd-search:focus { outline: 2px solid rgba(59, 130, 246, 0.35); outline-offset: 0; }
.swd-side-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0.35rem 0.75rem 0.25rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.swd-side-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 0 0.45rem 0.5rem;
  min-height: 60px;
}
.swd-side-row {
  display: flex;
  align-items: stretch;
  gap: 2px;
  border-radius: 7px;
  padding: 1px;
}
.swd-side-row:hover { background: var(--bg-toolbar); }
.swd-side-row.is-hidden .swd-side-info { opacity: 0.45; }
.swd-eye {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 0 4px;
  border-radius: 5px;
  opacity: 0.65;
}
.swd-eye:hover { opacity: 1; background: var(--bg-input, var(--bg-toolbar)); }
.swd-side-info {
  flex: 1 1;
  min-width: 0;
  text-align: left;
  border: none;
  background: none;
  cursor: pointer;
  padding: 5px 4px;
  display: flex;
  flex-direction: column;
  gap: 1px;
  color: inherit;
}
.swd-side-name {
  font-size: 0.79rem;
  font-weight: 600;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.swd-side-meta {
  font-size: 0.68rem;
  color: var(--text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.swd-empty {
  padding: 1rem 0.5rem;
  text-align: center;
  font-size: 0.76rem;
  color: var(--text-muted);
}

/* ── Leyenda ─────────────────────────────────────────────────────────────── */
.swd-legend {
  border-top: 1px solid var(--border);
  padding: 0.5rem 0.75rem 0.6rem;
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex-shrink: 0;
}
.swd-legend-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.7rem;
  color: var(--text-muted);
}
.swd-dot {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  display: inline-block;
  border: 1px solid rgba(15, 23, 42, 0.25);
  flex-shrink: 0;
}
.swd-dot.is-free { background: var(--bg-input, #f8fafc); }
.swd-dot.is-switch { background: #2563eb; }
.swd-dot.is-mirror { background: transparent; border: 1.5px dashed #8b5cf6; }
.swd-dot.is-other { background: #7c3aed; }
.swd-dot.is-off { background: var(--bg-toolbar, #e2e8f0); opacity: 0.6; }
.swd-dot.is-poe { background: #f59e0b; }
.swd-legend-tip {
  margin-top: 4px;
  font-size: 0.66rem;
  color: var(--text-muted);
  line-height: 1.35;
}

/* ── Lienzo ──────────────────────────────────────────────────────────────── */
.swd-canvas-wrap {
  position: relative;
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: var(--bg-toolbar);
}

/* ── Móvil y tablet estrecha ───────────────────────────────────────────────
   En columna el panel de nodos de 268 px dejaba el lienzo en una franja (y en
   un móvil de 288 px útiles, directamente en cero). Ahora el panel va arriba
   con altura limitada y el lienzo ocupa el resto. La barra de herramientas se
   desliza en horizontal: los botones son muchos y no caben con texto. */
@media (max-width: 900px) {
  .swd-toolbar {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    gap: 0.45rem;
    padding: 0.45rem 0.6rem;
  }

  .swd-toolbar::-webkit-scrollbar { display: none; }
  .swd-toolbar > * { flex-shrink: 0; }

  .swd-title { font-size: 0.82rem; }
  .swd-stats,
  .swd-sel-hint,
  .swd-legend { display: none; }

  .swd-body {
    flex-direction: column;
  }

  .swd-side {
    width: 100%;
    max-height: 30dvh;
    flex: 0 0 auto;
    border-right: 0;
    border-bottom: 1px solid var(--border);
  }

  .swd-canvas-wrap {
    flex: 1 1 auto;
    min-height: 46dvh;
  }

  .swd-zoom {
    right: 10px;
    bottom: 10px;
  }
}
.swd-svg {
  display: block;
  width: 100%;
  height: 100%;
  cursor: default;
}
.swd-bg { pointer-events: all; }

.swd-canvas-empty {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.86rem;
  pointer-events: none;
}
.swd-canvas-empty-ic { font-size: 2.2rem; }
.swd-canvas-empty-sub { font-size: 0.76rem; max-width: 340px; }

.swd-zoom {
  position: absolute;
  right: 14px;
  bottom: 14px;
  display: flex;
  align-items: stretch;
  border: 1px solid var(--slate-300, #cbd5e1);
  border-radius: 8px;
  overflow: hidden;
  background: var(--bg-card);
  box-shadow: var(--shadow-lg, 0 6px 16px rgba(15, 23, 42, 0.12));
}
.swd-zoom button {
  border: none;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.78rem;
  font-weight: 700;
  padding: 5px 10px;
  cursor: pointer;
  min-width: 38px;
}
.swd-zoom button:hover { background: var(--bg-toolbar); }

/* ── Tarjeta de switch ───────────────────────────────────────────────────── */
.swd-card-rect {
  fill: var(--bg-surface, var(--bg-card));
  stroke: var(--slate-300, #cbd5e1);
  stroke-width: 1.4;
  filter: drop-shadow(0 2px 5px rgba(15, 23, 42, 0.14));
  cursor: grab;
}
.swd-card:hover .swd-card-rect { stroke: var(--swd-accent); }
.swd-card-info {
  fill: var(--bg-toolbar);
  cursor: grab;
}
.swd-card-head-text { cursor: grab; }
.swd-card-name {
  font-size: 12px;
  font-weight: 700;
  fill: var(--text-primary);
}
.swd-card-sub {
  font-size: 9px;
  fill: var(--text-muted);
}
.swd-card-empty {
  font-size: 10px;
  fill: var(--text-muted);
}

/* Switch en diseño: borde discontinuo para distinguirlo de producción. */
.swd-card.is-design .swd-card-rect {
  stroke-dasharray: 6 4;
  stroke: #d97706;
}

/* ── Etiquetas de puerto (rotulado de puertos libres) ───────────────────── */
.swd-port-label { pointer-events: none; }
.swd-port-label rect {
  fill: var(--bg-surface, var(--bg-card));
  stroke: var(--slate-300, #cbd5e1);
  stroke-width: 0.6;
}
.swd-port-label text {
  font-size: 6.5px;
  font-weight: 600;
  fill: var(--text-secondary);
}

/* ── Puertos ─────────────────────────────────────────────────────────────── */
.swd-port { cursor: pointer; }
.swd-port rect {
  stroke-width: 1;
  transition: fill 0.1s, stroke 0.1s;
}
.swd-port-num {
  font-size: 7px;
  fill: var(--text-muted);
  pointer-events: none;
}
.swd-port.is-switch .swd-port-num,
.swd-port.is-other .swd-port-num {
  fill: #fff;
  opacity: 0.9;
}
.swd-port.is-selected .swd-port-num { fill: #78350f; }
.swd-port.is-free rect {
  fill: var(--bg-input, #f8fafc);
  stroke: var(--slate-300, #cbd5e1);
}
.swd-port.is-free:hover rect {
  fill: rgba(59, 130, 246, 0.18);
  stroke: var(--swd-accent);
}
.swd-port.is-switch rect {
  fill: #2563eb;
  stroke: #1d4ed8;
}
.swd-port.is-other rect {
  fill: #7c3aed;
  stroke: #6d28d9;
}
.swd-port.is-legacy rect {
  fill: rgba(245, 158, 11, 0.55);
  stroke: #d97706;
}
.swd-port.is-off rect {
  fill: var(--bg-toolbar);
  stroke: var(--slate-300, #cbd5e1);
  stroke-dasharray: 2 2;
  opacity: 0.55;
}
.swd-port.is-selected rect {
  stroke: #f59e0b;
  stroke-width: 2.4;
  fill: rgba(245, 158, 11, 0.35);
}
.swd-port.is-peer rect {
  stroke: #f59e0b;
  stroke-width: 2;
}
/* Puertos del cable que se está mirando: parpadeo fosforito. */
.swd-port.is-blaze rect {
  stroke: var(--accent, #8b5cf6);
  stroke-width: 2.8;
  filter: drop-shadow(0 0 7px var(--accent, #8b5cf6));
  animation: swd-port-blaze 0.85s ease-in-out infinite;
}
.swd-port.is-blaze .swd-port-num {
  font-weight: 800;
  animation: swd-port-blaze 0.85s ease-in-out infinite;
}
@keyframes swd-port-blaze {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.35; }
}
.swd-port:hover rect { filter: brightness(1.06); }
.swd-port-poe {
  fill: #f59e0b;
  stroke: rgba(15, 23, 42, 0.35);
  stroke-width: 0.6;
  pointer-events: none;
}

/* ── Cables ──────────────────────────────────────────────────────────────── */
.swd-edge-hit {
  fill: none;
  stroke: transparent;
  stroke-width: 13;
  cursor: pointer;
}
.swd-edge-line {
  fill: none;
  stroke-width: 2;
  opacity: 0.85;
  pointer-events: none;
  stroke-linejoin: round;
  stroke-linecap: round;
}
/* Enlace a través de panel/toma: discontinuo y fino, no es un latiguillo. */
.swd-edge.is-mirror .swd-edge-line {
  stroke-width: 2.2;
  opacity: 0.9;
  pointer-events: stroke;
}
.swd-edge.is-mirror.is-hover .swd-edge-line { stroke-width: 4; opacity: 1; }
.swd-cable-label.is-mirror text { fill: #7c3aed; }
/* Cable resaltado: gordo, con halo fosforito y parpadeo suave. */
.swd-edge.is-hover .swd-edge-line {
  stroke-width: 7;
  opacity: 1;
  filter: url(#swd-hot);
  animation: swd-edge-blaze 1s ease-in-out infinite;
}
@keyframes swd-edge-blaze {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.55; }
}.swd-edge-ghost {
  fill: none;
  stroke-width: 2;
  stroke-dasharray: 6 4;
  opacity: 0.85;
  pointer-events: none;
}

/* Latiguillo interior: del puerto al borde de la tarjeta (por dentro). */
.swd-lead {
  stroke-width: 2;
  stroke-linecap: round;
  opacity: 0.9;
  pointer-events: none;
}

/* Etiquetas de los cables (caja con borde discontinuo del color del cable). */
.swd-cable-label { pointer-events: none; }
.swd-cable-label rect {
  fill: var(--bg-surface, var(--bg-card));
  fill-opacity: 0.94;
  stroke-width: 1;
  stroke-dasharray: 4 3;
}
.swd-cable-label text {
  font-size: 8px;
  font-weight: 600;
  fill: var(--text-secondary);
}
.swd-lead.is-ghost {
  stroke: var(--swd-accent);
  stroke-dasharray: 5 3;
}
.swd-lead.is-hover { stroke-width: 3.2; opacity: 1; }

/* ── Modales ─────────────────────────────────────────────────────────────── */
.swd-overlay {
  position: fixed;
  inset: 0;
  z-index: 2500;
  background: var(--modal-overlay, rgba(15, 23, 42, 0.55));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  -webkit-user-select: text;
          user-select: text;
}
.swd-modal {
  width: 640px;
  max-width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  background: var(--bg-surface, var(--bg-card));
  border: 1px solid var(--slate-300, #cbd5e1);
  border-radius: 14px;
  padding: 1.25rem 1.4rem 1.1rem;
  box-shadow: var(--shadow-lg, 0 18px 40px rgba(15, 23, 42, 0.28));
}
.swd-modal-title {
  margin: 0 0 0.9rem;
  font-size: 1.02rem;
  color: var(--text-primary);
}
.swd-endpoints {
  display: flex;
  align-items: stretch;
  gap: 8px;
  margin-bottom: 1rem;
}
.swd-endpoint {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0.55rem 0.7rem;
  border-radius: 9px;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  min-width: 0;
}
.swd-endpoint strong {
  font-size: 0.86rem;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.swd-endpoint-tag {
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.swd-endpoint-port {
  font-size: 0.78rem;
  color: var(--swd-accent);
  font-weight: 700;
}
.swd-endpoint-arrow {
  align-self: center;
  font-size: 1.1rem;
  color: var(--text-muted);
}
.swd-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.7rem 1rem;
  margin-bottom: 0.6rem;
}
.swd-form-grid label {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--text-muted);
}
.swd-form-grid input,
.swd-form-grid select {
  padding: 0.38rem 0.5rem;
  border-radius: 7px;
  border: 1px solid var(--slate-300, #cbd5e1);
  background: var(--bg-input, var(--bg-toolbar));
  color: var(--text-primary);
  font-size: 0.81rem;
  font-weight: 400;
}
.swd-field-hint {
  font-size: 0.68rem;
  font-weight: 400;
  color: var(--text-muted);
  line-height: 1.35;
}
.swd-field-hint code {
  font-size: 0.68rem;
  padding: 0 3px;
  border-radius: 3px;
  background: rgba(var(--accent-rgb), 0.12);
}
.swd-modal-hint {
  margin: 0.2rem 0 0.9rem;
  font-size: 0.73rem;
  color: var(--text-muted);
  line-height: 1.45;
}
.swd-modal-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SwitchWiringCanvas.css"],"names":[],"mappings":"AAAA;;iFAEiF;;AAEjF;EACE,qBAAqB;EACrB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,mEAAmE;AACnE,sBAAsB,2BAA2B,EAAE;;AAEnD;;mCAEmC;AACnC;EACE;wBACsB,4BAA4B,EAAE;AACtD;;AAEA,yDAAyD;AACzD;;EAEE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;oCACoC,aAAa,EAAE;;AAEnD,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,0BAA0B;EAC1B,sCAAsC;EACtC,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA,sEAAsE;AACtE;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;AACA,cAAc,SAAO,EAAE;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,8CAA8C;EAC9C,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,8CAA8C;EAC9C,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;AACA,iBAAiB,+BAA+B,EAAE;AAClD,oBAAoB,aAAa,EAAE,eAAe,EAAE;AACpD;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA,oBAAoB,uBAAuB,EAAE;AAC7C;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;AACA,kBAAkB,0BAA0B,EAAE;;AAE9C,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,kBAAkB;EAClB,2CAA2C;EAC3C,8CAA8C;EAC9C,0BAA0B;EAC1B,kBAAkB;AACpB;AACA,oBAAoB,2CAA2C,EAAE,iBAAiB,EAAE;AACpF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;AACA,sBAAsB,6BAA6B,EAAE;AACrD,yCAAyC,aAAa,EAAE;AACxD;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;AACA,iBAAiB,UAAU,EAAE,8CAA8C,EAAE;AAC7E;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,+EAA+E;AAC/E;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;EACxC,cAAc;AAChB;AACA,mBAAmB,oCAAoC,EAAE;AACzD,qBAAqB,mBAAmB,EAAE;AAC1C,qBAAqB,uBAAuB,EAAE,4BAA4B,EAAE;AAC5E,oBAAoB,mBAAmB,EAAE;AACzC,kBAAkB,sCAAsC,EAAE,YAAY,EAAE;AACxE,kBAAkB,mBAAmB,EAAE;AACvC;EACE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;;;wEAIwE;AACxE;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;EACzB;;EAEA,kCAAkC,aAAa,EAAE;EACjD,mBAAmB,cAAc,EAAE;;EAEnC,aAAa,kBAAkB,EAAE;EACjC;;gBAEc,aAAa,EAAE;;EAE7B;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA,UAAU,mBAAmB,EAAE;;AAE/B;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;AACtB;AACA,uBAAuB,iBAAiB,EAAE;AAC1C,wBAAwB,kBAAkB,EAAE,gBAAgB,EAAE;;AAE9D;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,+DAA+D;AACjE;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;AACA,yBAAyB,6BAA6B,EAAE;;AAExD,+EAA+E;AAC/E;EACE,uCAAuC;EACvC,iCAAiC;EACjC,iBAAiB;EACjB,qDAAqD;EACrD,YAAY;AACd;AACA,iCAAiC,yBAAyB,EAAE;AAC5D;EACE,uBAAuB;EACvB,YAAY;AACd;AACA,sBAAsB,YAAY,EAAE;AACpC;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA,yEAAyE;AACzE;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA,8EAA8E;AAC9E,kBAAkB,oBAAoB,EAAE;AACxC;EACE,uCAAuC;EACvC,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,+EAA+E;AAC/E,YAAY,eAAe,EAAE;AAC7B;EACE,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,YAAY;AACd;AACA,sCAAsC,aAAa,EAAE;AACrD;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA,+DAA+D;AAC/D;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,mDAAmD;EACnD,oDAAoD;AACtD;AACA;EACE,gBAAgB;EAChB,oDAAoD;AACtD;AACA;EACE,WAAW,UAAU,EAAE;EACvB,WAAW,aAAa,EAAE;AAC5B;AACA,uBAAuB,wBAAwB,EAAE;AACjD;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,+EAA+E;AAC/E;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;AACvB;AACA,4EAA4E;AAC5E;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;AACA,8CAA8C,eAAe,EAAE,UAAU,EAAE;AAC3E,kCAAkC,aAAa,EAAE;AACjD,iEAAiE;AACjE;EACE,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,iDAAiD;AACnD;AACA;EACE,WAAW,UAAU,EAAE;EACvB,WAAW,aAAa,EAAE;AAC5B,CAAC;EACC,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,oBAAoB;AACtB;;AAEA,yEAAyE;AACzE;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,oBAAoB;AACtB;;AAEA,8EAA8E;AAC9E,mBAAmB,oBAAoB,EAAE;AACzC;EACE,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA,qBAAqB,iBAAiB,EAAE,UAAU,EAAE;;AAEpD,+EAA+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,wDAAwD;EACxD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,2CAA2C;EAC3C,mBAAmB;EACnB,8BAA8B;EAC9B,gEAAgE;AAClE;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,8CAA8C;EAC9C,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":["/* ────────────────────────────────────────────────────────────────────────────\r\n   SwitchWiringCanvas — diseñador visual de interconexión de switches (Visio)\r\n   ──────────────────────────────────────────────────────────────────────────── */\r\n\r\n.swd-page {\r\n  --swd-accent: #3b82f6;\r\n  --swd-grid-dot: rgba(148, 163, 184, 0.35);\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: calc(100vh - 196px);\r\n  min-height: 420px;\r\n  background: var(--bg-card);\r\n  color: var(--text-primary);\r\n  user-select: none;\r\n}\r\n/* Dentro de la pestaña Cableado hay además la barra de pestañas. */\r\n.swd-page.is-tabbed { height: calc(100vh - 250px); }\r\n\r\n/* Portátil bajo (14\"): el relleno de página se recorta (MainLayout.css), así\r\n   que al lienzo le toca más alto. Mismo cálculo: viewport − barra superior −\r\n   migas − relleno del contenido. */\r\n@media (max-height: 820px) {\r\n  .swd-page,\r\n  .swd-page.is-tabbed { height: calc(100dvh - 150px); }\r\n}\r\n\r\n/* Pantalla completa: el lienzo ocupa todo el viewport. */\r\n.swd-page:fullscreen,\r\n.swd-page.is-fullscreen {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  border-radius: 0;\r\n}\r\n.swd-page:fullscreen.is-tabbed,\r\n.swd-page.is-fullscreen.is-tabbed { height: 100vh; }\r\n\r\n/* ── Barra de herramientas ───────────────────────────────────────────────── */\r\n.swd-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 0.6rem 1rem;\r\n  background: var(--bg-card);\r\n  border-bottom: 1px solid var(--border);\r\n  flex-wrap: wrap;\r\n  flex-shrink: 0;\r\n}\r\n.swd-title {\r\n  font-weight: 700;\r\n  font-size: 0.9rem;\r\n  white-space: nowrap;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n}\r\n/* Icono del título (heroicons), compartido por los dos diseñadores. */\r\n.swd-title .cbd-ico {\r\n  width: 18px;\r\n  height: 18px;\r\n  flex: 0 0 auto;\r\n  stroke-width: 1.8;\r\n  color: var(--swd-accent);\r\n}\r\n.swd-stats {\r\n  font-size: 0.74rem;\r\n  color: var(--text-muted);\r\n  white-space: nowrap;\r\n}\r\n.swd-spacer { flex: 1; }\r\n.swd-sel-hint {\r\n  font-size: 0.73rem;\r\n  font-weight: 700;\r\n  color: #b45309;\r\n  background: var(--amber-50, #fef3c7);\r\n  border: 1px solid rgba(245, 158, 11, 0.45);\r\n  border-radius: 6px;\r\n  padding: 3px 9px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Selector de escenario (producción / diseño / sede) */\r\n.swd-scenario {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  color: var(--text-muted);\r\n  white-space: nowrap;\r\n}\r\n.swd-scenario select {\r\n  padding: 4px 8px;\r\n  border-radius: 7px;\r\n  border: 1px solid var(--slate-300, #cbd5e1);\r\n  background: var(--bg-input, var(--bg-toolbar));\r\n  color: var(--text-primary);\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.swd-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 5px 11px;\r\n  border-radius: 7px;\r\n  border: 1px solid var(--slate-300, #cbd5e1);\r\n  background: var(--bg-input, var(--bg-toolbar));\r\n  color: var(--text-primary);\r\n  font-size: 0.79rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.12s, border-color 0.12s;\r\n}\r\n.swd-btn:hover { border-color: var(--swd-accent); }\r\n.swd-btn:disabled { opacity: 0.55; cursor: default; }\r\n.swd-btn.is-primary {\r\n  background: var(--swd-accent);\r\n  border-color: var(--swd-accent);\r\n  color: #fff;\r\n}\r\n.swd-btn.is-danger {\r\n  background: #dc2626;\r\n  border-color: #dc2626;\r\n  color: #fff;\r\n}\r\n.swd-btn.is-ghost { background: transparent; }\r\n.swd-btn.is-on {\r\n  border-color: var(--swd-accent);\r\n  color: var(--swd-accent);\r\n  background: rgba(var(--accent-rgb), 0.1);\r\n}\r\n\r\n.swd-link {\r\n  border: none;\r\n  background: none;\r\n  color: var(--swd-accent);\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n.swd-link:hover { text-decoration: underline; }\r\n\r\n/* ── Avisos ──────────────────────────────────────────────────────────────── */\r\n.swd-banner {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 0.4rem 1rem;\r\n  font-size: 0.79rem;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n.swd-banner.is-error {\r\n  background: var(--error-bg, #fef2f2);\r\n  color: var(--error-text, #b91c1c);\r\n}\r\n.swd-banner.is-notice {\r\n  background: rgba(59, 130, 246, 0.1);\r\n  color: var(--text-primary);\r\n}\r\n.swd-banner button {\r\n  margin-left: auto;\r\n  border: none;\r\n  background: none;\r\n  color: inherit;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n}\r\n\r\n/* ── Cuerpo: lateral + lienzo ────────────────────────────────────────────── */\r\n.swd-body {\r\n  display: flex;\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.swd-side {\r\n  width: 268px;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-right: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  min-height: 0;\r\n}\r\n.swd-search {\r\n  margin: 0.6rem 0.7rem 0.35rem;\r\n  padding: 0.38rem 0.55rem;\r\n  border-radius: 7px;\r\n  border: 1px solid var(--slate-300, #cbd5e1);\r\n  background: var(--bg-input, var(--bg-toolbar));\r\n  color: var(--text-primary);\r\n  font-size: 0.78rem;\r\n}\r\n.swd-search:focus { outline: 2px solid rgba(59, 130, 246, 0.35); outline-offset: 0; }\r\n.swd-side-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  padding: 0.35rem 0.75rem 0.25rem;\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n}\r\n.swd-side-list {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 0 0.45rem 0.5rem;\r\n  min-height: 60px;\r\n}\r\n.swd-side-row {\r\n  display: flex;\r\n  align-items: stretch;\r\n  gap: 2px;\r\n  border-radius: 7px;\r\n  padding: 1px;\r\n}\r\n.swd-side-row:hover { background: var(--bg-toolbar); }\r\n.swd-side-row.is-hidden .swd-side-info { opacity: 0.45; }\r\n.swd-eye {\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n  font-size: 0.8rem;\r\n  padding: 0 4px;\r\n  border-radius: 5px;\r\n  opacity: 0.65;\r\n}\r\n.swd-eye:hover { opacity: 1; background: var(--bg-input, var(--bg-toolbar)); }\r\n.swd-side-info {\r\n  flex: 1;\r\n  min-width: 0;\r\n  text-align: left;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n  padding: 5px 4px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  color: inherit;\r\n}\r\n.swd-side-name {\r\n  font-size: 0.79rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.swd-side-meta {\r\n  font-size: 0.68rem;\r\n  color: var(--text-muted);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.swd-empty {\r\n  padding: 1rem 0.5rem;\r\n  text-align: center;\r\n  font-size: 0.76rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* ── Leyenda ─────────────────────────────────────────────────────────────── */\r\n.swd-legend {\r\n  border-top: 1px solid var(--border);\r\n  padding: 0.5rem 0.75rem 0.6rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n  flex-shrink: 0;\r\n}\r\n.swd-legend-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 0.7rem;\r\n  color: var(--text-muted);\r\n}\r\n.swd-dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 3px;\r\n  display: inline-block;\r\n  border: 1px solid rgba(15, 23, 42, 0.25);\r\n  flex-shrink: 0;\r\n}\r\n.swd-dot.is-free { background: var(--bg-input, #f8fafc); }\r\n.swd-dot.is-switch { background: #2563eb; }\r\n.swd-dot.is-mirror { background: transparent; border: 1.5px dashed #8b5cf6; }\r\n.swd-dot.is-other { background: #7c3aed; }\r\n.swd-dot.is-off { background: var(--bg-toolbar, #e2e8f0); opacity: 0.6; }\r\n.swd-dot.is-poe { background: #f59e0b; }\r\n.swd-legend-tip {\r\n  margin-top: 4px;\r\n  font-size: 0.66rem;\r\n  color: var(--text-muted);\r\n  line-height: 1.35;\r\n}\r\n\r\n/* ── Lienzo ──────────────────────────────────────────────────────────────── */\r\n.swd-canvas-wrap {\r\n  position: relative;\r\n  flex: 1;\r\n  min-width: 0;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  background: var(--bg-toolbar);\r\n}\r\n\r\n/* ── Móvil y tablet estrecha ───────────────────────────────────────────────\r\n   En columna el panel de nodos de 268 px dejaba el lienzo en una franja (y en\r\n   un móvil de 288 px útiles, directamente en cero). Ahora el panel va arriba\r\n   con altura limitada y el lienzo ocupa el resto. La barra de herramientas se\r\n   desliza en horizontal: los botones son muchos y no caben con texto. */\r\n@media (max-width: 900px) {\r\n  .swd-toolbar {\r\n    flex-wrap: nowrap;\r\n    overflow-x: auto;\r\n    scrollbar-width: none;\r\n    gap: 0.45rem;\r\n    padding: 0.45rem 0.6rem;\r\n  }\r\n\r\n  .swd-toolbar::-webkit-scrollbar { display: none; }\r\n  .swd-toolbar > * { flex-shrink: 0; }\r\n\r\n  .swd-title { font-size: 0.82rem; }\r\n  .swd-stats,\r\n  .swd-sel-hint,\r\n  .swd-legend { display: none; }\r\n\r\n  .swd-body {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .swd-side {\r\n    width: 100%;\r\n    max-height: 30dvh;\r\n    flex: 0 0 auto;\r\n    border-right: 0;\r\n    border-bottom: 1px solid var(--border);\r\n  }\r\n\r\n  .swd-canvas-wrap {\r\n    flex: 1 1 auto;\r\n    min-height: 46dvh;\r\n  }\r\n\r\n  .swd-zoom {\r\n    right: 10px;\r\n    bottom: 10px;\r\n  }\r\n}\r\n.swd-svg {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  cursor: default;\r\n}\r\n.swd-bg { pointer-events: all; }\r\n\r\n.swd-canvas-empty {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  text-align: center;\r\n  color: var(--text-muted);\r\n  font-size: 0.86rem;\r\n  pointer-events: none;\r\n}\r\n.swd-canvas-empty-ic { font-size: 2.2rem; }\r\n.swd-canvas-empty-sub { font-size: 0.76rem; max-width: 340px; }\r\n\r\n.swd-zoom {\r\n  position: absolute;\r\n  right: 14px;\r\n  bottom: 14px;\r\n  display: flex;\r\n  align-items: stretch;\r\n  border: 1px solid var(--slate-300, #cbd5e1);\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  background: var(--bg-card);\r\n  box-shadow: var(--shadow-lg, 0 6px 16px rgba(15, 23, 42, 0.12));\r\n}\r\n.swd-zoom button {\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--text-primary);\r\n  font-size: 0.78rem;\r\n  font-weight: 700;\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n  min-width: 38px;\r\n}\r\n.swd-zoom button:hover { background: var(--bg-toolbar); }\r\n\r\n/* ── Tarjeta de switch ───────────────────────────────────────────────────── */\r\n.swd-card-rect {\r\n  fill: var(--bg-surface, var(--bg-card));\r\n  stroke: var(--slate-300, #cbd5e1);\r\n  stroke-width: 1.4;\r\n  filter: drop-shadow(0 2px 5px rgba(15, 23, 42, 0.14));\r\n  cursor: grab;\r\n}\r\n.swd-card:hover .swd-card-rect { stroke: var(--swd-accent); }\r\n.swd-card-info {\r\n  fill: var(--bg-toolbar);\r\n  cursor: grab;\r\n}\r\n.swd-card-head-text { cursor: grab; }\r\n.swd-card-name {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  fill: var(--text-primary);\r\n}\r\n.swd-card-sub {\r\n  font-size: 9px;\r\n  fill: var(--text-muted);\r\n}\r\n.swd-card-empty {\r\n  font-size: 10px;\r\n  fill: var(--text-muted);\r\n}\r\n\r\n/* Switch en diseño: borde discontinuo para distinguirlo de producción. */\r\n.swd-card.is-design .swd-card-rect {\r\n  stroke-dasharray: 6 4;\r\n  stroke: #d97706;\r\n}\r\n\r\n/* ── Etiquetas de puerto (rotulado de puertos libres) ───────────────────── */\r\n.swd-port-label { pointer-events: none; }\r\n.swd-port-label rect {\r\n  fill: var(--bg-surface, var(--bg-card));\r\n  stroke: var(--slate-300, #cbd5e1);\r\n  stroke-width: 0.6;\r\n}\r\n.swd-port-label text {\r\n  font-size: 6.5px;\r\n  font-weight: 600;\r\n  fill: var(--text-secondary);\r\n}\r\n\r\n/* ── Puertos ─────────────────────────────────────────────────────────────── */\r\n.swd-port { cursor: pointer; }\r\n.swd-port rect {\r\n  stroke-width: 1;\r\n  transition: fill 0.1s, stroke 0.1s;\r\n}\r\n.swd-port-num {\r\n  font-size: 7px;\r\n  fill: var(--text-muted);\r\n  pointer-events: none;\r\n}\r\n.swd-port.is-switch .swd-port-num,\r\n.swd-port.is-other .swd-port-num {\r\n  fill: #fff;\r\n  opacity: 0.9;\r\n}\r\n.swd-port.is-selected .swd-port-num { fill: #78350f; }\r\n.swd-port.is-free rect {\r\n  fill: var(--bg-input, #f8fafc);\r\n  stroke: var(--slate-300, #cbd5e1);\r\n}\r\n.swd-port.is-free:hover rect {\r\n  fill: rgba(59, 130, 246, 0.18);\r\n  stroke: var(--swd-accent);\r\n}\r\n.swd-port.is-switch rect {\r\n  fill: #2563eb;\r\n  stroke: #1d4ed8;\r\n}\r\n.swd-port.is-other rect {\r\n  fill: #7c3aed;\r\n  stroke: #6d28d9;\r\n}\r\n.swd-port.is-legacy rect {\r\n  fill: rgba(245, 158, 11, 0.55);\r\n  stroke: #d97706;\r\n}\r\n.swd-port.is-off rect {\r\n  fill: var(--bg-toolbar);\r\n  stroke: var(--slate-300, #cbd5e1);\r\n  stroke-dasharray: 2 2;\r\n  opacity: 0.55;\r\n}\r\n.swd-port.is-selected rect {\r\n  stroke: #f59e0b;\r\n  stroke-width: 2.4;\r\n  fill: rgba(245, 158, 11, 0.35);\r\n}\r\n.swd-port.is-peer rect {\r\n  stroke: #f59e0b;\r\n  stroke-width: 2;\r\n}\r\n/* Puertos del cable que se está mirando: parpadeo fosforito. */\r\n.swd-port.is-blaze rect {\r\n  stroke: var(--accent, #8b5cf6);\r\n  stroke-width: 2.8;\r\n  filter: drop-shadow(0 0 7px var(--accent, #8b5cf6));\r\n  animation: swd-port-blaze 0.85s ease-in-out infinite;\r\n}\r\n.swd-port.is-blaze .swd-port-num {\r\n  font-weight: 800;\r\n  animation: swd-port-blaze 0.85s ease-in-out infinite;\r\n}\r\n@keyframes swd-port-blaze {\r\n  0%, 100% { opacity: 1; }\r\n  50%      { opacity: 0.35; }\r\n}\r\n.swd-port:hover rect { filter: brightness(1.06); }\r\n.swd-port-poe {\r\n  fill: #f59e0b;\r\n  stroke: rgba(15, 23, 42, 0.35);\r\n  stroke-width: 0.6;\r\n  pointer-events: none;\r\n}\r\n\r\n/* ── Cables ──────────────────────────────────────────────────────────────── */\r\n.swd-edge-hit {\r\n  fill: none;\r\n  stroke: transparent;\r\n  stroke-width: 13;\r\n  cursor: pointer;\r\n}\r\n.swd-edge-line {\r\n  fill: none;\r\n  stroke-width: 2;\r\n  opacity: 0.85;\r\n  pointer-events: none;\r\n  stroke-linejoin: round;\r\n  stroke-linecap: round;\r\n}\r\n/* Enlace a través de panel/toma: discontinuo y fino, no es un latiguillo. */\r\n.swd-edge.is-mirror .swd-edge-line {\r\n  stroke-width: 2.2;\r\n  opacity: 0.9;\r\n  pointer-events: stroke;\r\n}\r\n.swd-edge.is-mirror.is-hover .swd-edge-line { stroke-width: 4; opacity: 1; }\r\n.swd-cable-label.is-mirror text { fill: #7c3aed; }\r\n/* Cable resaltado: gordo, con halo fosforito y parpadeo suave. */\r\n.swd-edge.is-hover .swd-edge-line {\r\n  stroke-width: 7;\r\n  opacity: 1;\r\n  filter: url(#swd-hot);\r\n  animation: swd-edge-blaze 1s ease-in-out infinite;\r\n}\r\n@keyframes swd-edge-blaze {\r\n  0%, 100% { opacity: 1; }\r\n  50%      { opacity: 0.55; }\r\n}.swd-edge-ghost {\r\n  fill: none;\r\n  stroke-width: 2;\r\n  stroke-dasharray: 6 4;\r\n  opacity: 0.85;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Latiguillo interior: del puerto al borde de la tarjeta (por dentro). */\r\n.swd-lead {\r\n  stroke-width: 2;\r\n  stroke-linecap: round;\r\n  opacity: 0.9;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Etiquetas de los cables (caja con borde discontinuo del color del cable). */\r\n.swd-cable-label { pointer-events: none; }\r\n.swd-cable-label rect {\r\n  fill: var(--bg-surface, var(--bg-card));\r\n  fill-opacity: 0.94;\r\n  stroke-width: 1;\r\n  stroke-dasharray: 4 3;\r\n}\r\n.swd-cable-label text {\r\n  font-size: 8px;\r\n  font-weight: 600;\r\n  fill: var(--text-secondary);\r\n}\r\n.swd-lead.is-ghost {\r\n  stroke: var(--swd-accent);\r\n  stroke-dasharray: 5 3;\r\n}\r\n.swd-lead.is-hover { stroke-width: 3.2; opacity: 1; }\r\n\r\n/* ── Modales ─────────────────────────────────────────────────────────────── */\r\n.swd-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 2500;\r\n  background: var(--modal-overlay, rgba(15, 23, 42, 0.55));\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 1rem;\r\n  user-select: text;\r\n}\r\n.swd-modal {\r\n  width: 640px;\r\n  max-width: 100%;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  background: var(--bg-surface, var(--bg-card));\r\n  border: 1px solid var(--slate-300, #cbd5e1);\r\n  border-radius: 14px;\r\n  padding: 1.25rem 1.4rem 1.1rem;\r\n  box-shadow: var(--shadow-lg, 0 18px 40px rgba(15, 23, 42, 0.28));\r\n}\r\n.swd-modal-title {\r\n  margin: 0 0 0.9rem;\r\n  font-size: 1.02rem;\r\n  color: var(--text-primary);\r\n}\r\n.swd-endpoints {\r\n  display: flex;\r\n  align-items: stretch;\r\n  gap: 8px;\r\n  margin-bottom: 1rem;\r\n}\r\n.swd-endpoint {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  padding: 0.55rem 0.7rem;\r\n  border-radius: 9px;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  min-width: 0;\r\n}\r\n.swd-endpoint strong {\r\n  font-size: 0.86rem;\r\n  color: var(--text-primary);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.swd-endpoint-tag {\r\n  font-size: 0.62rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n}\r\n.swd-endpoint-port {\r\n  font-size: 0.78rem;\r\n  color: var(--swd-accent);\r\n  font-weight: 700;\r\n}\r\n.swd-endpoint-arrow {\r\n  align-self: center;\r\n  font-size: 1.1rem;\r\n  color: var(--text-muted);\r\n}\r\n.swd-form-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 0.7rem 1rem;\r\n  margin-bottom: 0.6rem;\r\n}\r\n.swd-form-grid label {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  color: var(--text-muted);\r\n}\r\n.swd-form-grid input,\r\n.swd-form-grid select {\r\n  padding: 0.38rem 0.5rem;\r\n  border-radius: 7px;\r\n  border: 1px solid var(--slate-300, #cbd5e1);\r\n  background: var(--bg-input, var(--bg-toolbar));\r\n  color: var(--text-primary);\r\n  font-size: 0.81rem;\r\n  font-weight: 400;\r\n}\r\n.swd-field-hint {\r\n  font-size: 0.68rem;\r\n  font-weight: 400;\r\n  color: var(--text-muted);\r\n  line-height: 1.35;\r\n}\r\n.swd-field-hint code {\r\n  font-size: 0.68rem;\r\n  padding: 0 3px;\r\n  border-radius: 3px;\r\n  background: rgba(var(--accent-rgb), 0.12);\r\n}\r\n.swd-modal-hint {\r\n  margin: 0.2rem 0 0.9rem;\r\n  font-size: 0.73rem;\r\n  color: var(--text-muted);\r\n  line-height: 1.45;\r\n}\r\n.swd-modal-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
